import React from 'react';
import { Button, EventCodelessIcon, InfoIcon } from 'tuui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './emptyContent.module.scss';

export const EmptyContent = () => {
    const [showBanner, setShowBanner] = React.useState(true);

    return (
        <>
            {showBanner && (
                <div className={styles['info-message-container']}>
                    <div className={styles['icon-message-container']}>
                        <InfoIcon className={styles['info-icon']} fontSize="small" />
                        <FormattedMessage
                            id="pixel.tester.empty.events.content.info.message"
                            defaultMessage="Test events appear in real time, but it may take up to 1 hour after you set up your event to see it in your analytics."
                            className={styles['info-message-text']}
                        />
                    </div>

                    <Button
                        onClick={() => {
                            setShowBanner(false);
                        }}
                        variant={Button.variant.text}
                        size={Button.size.sm}
                        className={styles['button']}
                    >
                        <FormattedMessage
                            id="pixel.tester.empty.events.content.info.message.button"
                            defaultMessage="Dismiss"
                        />
                    </Button>
                </div>
            )}
            <div className={styles['container']}>
                <EventCodelessIcon />
                <div className={styles['text-container']}>
                    <FormattedMessage
                        id="pixel.tester.empty.events.content.title"
                        defaultMessage="No Events Received"
                        className={styles['title']}
                    />
                    <FormattedMessage
                        id="pixel.tester.empty.events.content.description"
                        defaultMessage="Interact with your website to trigger events"
                        className={styles['description']}
                    />
                </div>
            </div>
        </>
    );
};
